import { render } from "./EnableSriovDevice.vue?vue&type=template&id=1f81339f&scoped=true"
import script from "./EnableSriovDevice.vue?vue&type=script&lang=js"
export * from "./EnableSriovDevice.vue?vue&type=script&lang=js"

import "./EnableSriovDevice.vue?vue&type=style&index=0&id=1f81339f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f81339f"]])

export default __exports__